import React from 'react';

import { Tab, Label } from './SidebarNavLink.styles';
import { useLocation, NavLink } from 'react-router-dom';
import { ApIcon, colors } from '@alixpartners/ui-components';

export const SidebarNavLink = ({ to, children, iconName, disabled }) => {
	const location = useLocation();
	const isActive = location.pathname.includes(to);

	return (
		<NavLink
			to={to}
			onClick={e => {
				if (disabled) {
					e.preventDefault();
				}
			}}
		>
			<Tab isActive={isActive} disabled={disabled}>
				<Label>{children}</Label>
				<ApIcon
					iconName={iconName}
					iconColor={disabled ? colors.grey5 : colors.grey8}
				/>
			</Tab>
		</NavLink>
	);
};

export default SidebarNavLink;
